import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    Grid, TextField, FormControl, InputLabel, Select, MenuItem,
    CircularProgress, Box
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { UsuarioSchema } from '../schemes/CriacaoUsuarios';

export default function ModalEdicaoUsuario({ open, onClose, onSave, usuario, isLoading }) {
    // Estado local do formulário, inicializado com os dados do usuario
    const [formData, setFormData] = useState({
        id: '',
        nm_usuario: '',
        tipo: 'C',
        nova_senha: ''
    });

    const [erroNomeusuario, seterroNomeusuario] = useState(false);
    const [erroNomeusuarioMessage, seterroNomeusuarioMessage] = useState('');

    const [erroSenhausuario, seterroSenhaUsuario] = useState(false);
    const [erroSenhaUsuarioMessage, seterroSenhaUsuarioMessage] = useState('');

    const [erroTipoUsuario, seterroTipoUsuario] = useState(false);
    const [erroTipoUsuarioMessage, seterroTipoUsuarioMessage] = useState('');



    // Popula o formulário quando o usuario a ser editado muda
    useEffect(() => {
        if (usuario) {
            setFormData({
                id: usuario.id,
                nm_usuario: usuario.nome || '',
                tipo: usuario.tipo || 'S',
                nova_senha: ''
            });
        }
    }, [usuario]);

    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();

        let id = formData.id?.toString().trim() || undefined;
        let nm_usuario = formData.nm_usuario;
        let tipo = formData.tipo;
        let senha = formData.nova_senha;

        const result = UsuarioSchema.safeParse({ id, nm_usuario, tipo, senha });

        if (!result.success) {
            const errors = result.error.format();

            if (errors.nm_usuario?._errors?.length) {
                seterroNomeusuario(true);
                seterroNomeusuarioMessage(errors.nm_usuario._errors[0]);
            } else {
                seterroNomeusuario(false);
                seterroNomeusuarioMessage('');
            }

            if (errors.senha?._errors?.length) {
                seterroSenhaUsuario(true);
                seterroSenhaUsuarioMessage(errors.senha._errors[0]);
            } else {
                seterroSenhaUsuario(false); // estava true no seu código
                seterroSenhaUsuarioMessage('');
            }

            if (errors.tipo?._errors?.length) {
                seterroTipoUsuario(true);
                seterroTipoUsuarioMessage(errors.tipo._errors[0]);
            } else {
                seterroTipoUsuario(false); // estava true no seu código
                seterroTipoUsuarioMessage('');
            }

            return;
        }

        onSave(formData);
    };


    // const handleSubmit = (e) => {
    //     e.preventDefault();

    //     let id = formData.id;
    //     let nm_usuario = formData.nm_usuario;
    //     let tipo = formData.tipo;
    //     let senha = formData.nova_senha;


    //     console.log('id do usuario', id)
    //     console.log('nome do usuario', nm_usuario)
    //     console.log('tipo de usuario', tipo)
    //     console.log('senha do usuaro', senha)

    //     const result = UsuarioSchema.safeParse({ id, nome: nm_usuario, status: tipo, senha });

    //     if (!result.success) {
    //         const errors = result.error.format();

    //         if (errors.nm_usuario?._errors?.length) {
    //             seterroNomeusuario(true);
    //             seterroNomeusuarioMessage(errors.nm_usuario._errors[0]);
    //         } else {
    //             seterroNomeusuario(false);
    //             seterroNomeusuarioMessage('');
    //         }

    //         if (errors.senha?._errors?.length) {
    //             seterroSenhaUsuario(true);
    //             seterroSenhaUsuarioMessage(errors.senha._errors[0]);
    //         } else {
    //             seterroSenhaUsuario(true);
    //             seterroSenhaUsuarioMessage('');
    //         }

    //         if (errors.tipo?._errors?.length) {
    //             seterroTipoUsuario(true)
    //             seterroTipoUsuarioMessage(errors.tipo._errors[0])
    //         } else {
    //             seterroTipoUsuario(true)
    //             seterroTipoUsuarioMessage('')
    //         }


    //         return;
    //     }

    //     console.log("passou")
    //     return
    //     onSave(formData);
    // };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Editar Usuário</DialogTitle>
            <Box
                component="form"
                onSubmit={handleSubmit}
            >
                <DialogContent>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                            <TextField
                                InputProps={{
                                    sx: { backgroundColor: 'white', color: 'black' }
                                }}
                                InputLabelProps={{
                                    sx: { bgcolor: 'white', px: 0.5, color: 'black' }
                                }}
                                fullWidth
                                name="nm_usuario"
                                value={formData.nm_usuario}
                                onChange={handleChange}
                                label="Nome do usuário"
                                required
                                error={erroNomeusuario}
                                helperText={erroNomeusuarioMessage}
                            />
                        </Grid>
                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                            <TextField
                                InputProps={{
                                    sx: { backgroundColor: 'white', color: 'black' }
                                }}
                                InputLabelProps={{
                                    sx: { bgcolor: 'white', px: 0.5, color: 'black' }
                                }}
                                fullWidth
                                name="nova_senha"
                                value={formData.nova_senha}
                                onChange={handleChange}
                                label="Nova senha do usuário"
                                error={erroSenhausuario}
                                helperText={erroSenhaUsuarioMessage}
                            />
                        </Grid>
                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>

                            <TextField
                                select
                                fullWidth
                                name="tipo"
                                value={formData.tipo}
                                onChange={handleChange}
                                label="Tipo"
                                InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                                InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                                error={erroTipoUsuario}
                                helperText={erroTipoUsuarioMessage}
                            >
                                <MenuItem value="M">Master</MenuItem>
                                <MenuItem value="C">Funcionário</MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="secondary">Cancelar</Button>
                    <Button
                        type="submit"
                        variant="outlined"
                        startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                        disabled={isLoading}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
}